import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON, isOk, authReq, getUrlParams, getToken} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function setLeadsFilters(filters) {
  return {
    type: constants.LEADS_FILTER_SAVE,
    filters
  };
}

export function leadsSave(leads) {
	return {
    type: constants.LEADS_SAVE,
    leads,
  };
}

export function leadsCloseAddDropdown() {
  return {
    type: constants.LEADS_CLOSE_ADD_DROPDOWN,
  };
}

export function leadsOpenAddDropdown(diamonds) {
  return {
    type: constants.LEADS_OPEN_ADD_DROPDOWN,
    diamonds
  };
}

export function leadsCloseShareDirectDropdown() {
  return {
    type: constants.LEADS_CLOSE_SHARE_DIRECT_DROPDOWN,
  };
}

export function leadsOpenShareDirectDropdown(diamonds, mode = 'DIAMOND') {
  return {
    type: constants.LEADS_OPEN_SHARE_DIRECT_DROPDOWN,
    diamonds,
    mode,
  };
}

export function leadsSaveDirectory(leads) {
	return {
    type: constants.LEADS_SAVE_DIRECTORY,
    leads,
  };
}


/******************************
*******  Asynchronous  ********
******************************/


export function fetchAutocomplete(leadsFilters, auth_token, signal=null) {

	return dispatch => {

		let first = true;
		let getParams = '';

		const authFilters = Object.assign({}, leadsFilters, {at: auth_token});

		// let filterKeys = Object.keys(authFilters);
		// for(let i = 0; i < filterKeys.length; i++) {

		// 	if(first) {
		// 		getParams = '?' + filterKeys[i] + '=' + encodeURIComponent(authFilters[filterKeys[i]]);
		// 	} else {
		// 		getParams += '&' + filterKeys[i] + '=' + encodeURIComponent(authFilters[filterKeys[i]]);
		// 	}
		// 	first = false;
		// }
		// let encodedParams = getParams;

		let url = api.CUSTOMER_API_URL + endpoint.USERS_CUSTOMERS_AUTOCOMPLETE + getUrlParams(authFilters);
		return fetch(url, {
		  method: 'get',
		  headers: api.HEADERS,
		  signal
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function fetchLeads(leadsFilters) {

	return dispatch => {

		let first = true;
		let getParams = '';

		const authFilters = Object.assign({}, leadsFilters, { at: getToken() });

		// let filterKeys = Object.keys(authFilters);
		// for(let i = 0; i < filterKeys.length; i++) {

		// 	if(first) {
		// 		getParams = '?' + filterKeys[i] + '=' + encodeURIComponent(authFilters[filterKeys[i]]);
		// 	} else {
		// 		getParams += '&' + filterKeys[i] + '=' + encodeURIComponent(authFilters[filterKeys[i]]);
		// 	}
		// 	first = false;
		// }
		// let encodedParams = getParams;

		let url = api.CUSTOMER_API_URL + endpoint.USERS_CUSTOMERS_SEARCH + getUrlParams(authFilters);
		return fetch(url, {
		  method: 'get',
		  headers: api.HEADERS
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function leadsExport(exportFilters, auth_token) {

	return dispatch => {

		let first = true;
		let getParams = '';

		const authFilters = Object.assign({}, exportFilters, {at: auth_token});

		let filterKeys = Object.keys(authFilters);
		for(let i = 0; i < filterKeys.length; i++) {

			if(first) {
				getParams = '?' + filterKeys[i] + '=' + encodeURIComponent(authFilters[filterKeys[i]]);
			} else {
				getParams += '&' + filterKeys[i] + '=' + encodeURIComponent(authFilters[filterKeys[i]]);
			}
			first = false;
		}
		let encodedParams = getParams;

		let url = api.API_URL + endpoint.LEADS_EXPORT + encodedParams;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function fetchCardsDirectory(cardId) {

	return dispatch => {
		let url = api.API_URL + endpoint.USERS_FETCH_CARD_DIRECTORY;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function fetchFullCard(customerNumber) {

	return dispatch => {
		let url = api.CUSTOMER_API_URL + endpoint.USERS_CUSTOMER_FETCH_BY_NUMBER + getUrlParams({ at: getToken(), id: customerNumber });
		return fetch(url, {
		  method: 'get',
		  headers: api.HEADERS,
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function leadsAddDiamonds(addData) {
	return dispatch => {
		let url = api.API_URL + endpoint.USERS_CARD_ADD_DIAMONDS;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(addData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function leadsRemoveDiamonds(addData) {
	return dispatch => {
		let url = api.API_URL + endpoint.USERS_CARD_REMOVE_DIAMONDS;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(addData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function leadsShareExternal(shareData) {
	return dispatch => {
		let url = api.API_URL + endpoint.LEADS_SHARE_EXTERNAL;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(shareData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function leadsShareExternalWatch(shareData) {
	return dispatch => {
		let url = api.API_URL + endpoint.LEADS_SHARE_EXTERNAL_WATCH;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(shareData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function leadsCreateExternalWatch(shareData) {
	return dispatch => {
		let url = api.API_URL + endpoint.LEADS_CREATE_EXTERNAL_WATCH;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(shareData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function leadsCreateExternal(shareData) {
	return dispatch => {
		let url = api.API_URL + endpoint.LEADS_CREATE_EXTERNAL;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(shareData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function fetchExternalShare(shareId) {

	return dispatch => {
		let url = api.API_URL + endpoint.LEADS_FETCH_EXTERNAL_SHARE + '?share_key=' + shareId;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function fetchSocialCard(cardId) {

	return dispatch => {
		let url = api.API_URL + endpoint.USERS_FETCH_SOCIAL_SHARE + '?share_key=' + cardId;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function leadsDeleteCard(deleteData) {
	return dispatch => {
		let url = api.API_URL + endpoint.LEADS_DELETE_CARD;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(deleteData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function leadsSendCard(sendData) {

	return dispatch => {

		let url = api.API_URL + endpoint.LEADS_SEND_CARD;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(sendData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}